<select
  class="form-select"
  [attr.id]="inputId"
  [disabled]="disabled"
  [class.is-invalid]="invalid"
  (change)="onSelect($event)"
  (blur)="onTouched()"
>
  <option value="" [selected]="value === ''">{{ placeholder }}</option>
  @for (state of states; track state.value) {
    <!-- Loop through each state and create an option element -->
    <!-- Display the state name, code, or both based on the 'display' input property -->
    <option [value]="state.value" [selected]="state.value === value">{{ display === 'code' ? state.value : display === 'name' ? state.label : state.label + ' - ' + state.value }}</option>
  }
</select>
    